export const LEAVE_TYPE_OPTIONS = [
  { id: "PAID", value: "Paid" },
  { id: "MEDICAL", value: "Medical" },
  { id: "CASUAL", value: "Casual" },
  { id: "UNPAID", value: "Leave without pay" },
];

export const LEAVE_STATUS_OPTIONS = [
  { id: "PENDING", value: "Pending" },
  { id: "APPROVED", value: "Approved" },
  { id: "REJECTED", value: "Rejected" },
];

export const LEAVE_STATUS_FILTER_OPTIONS = [
  { id: "ALL", value: "All statuses" },
  ...LEAVE_STATUS_OPTIONS,
];

export const AR_REQUEST_TYPES = [
  { id: "FORGOT_IN", label: "Forgot In" },
  { id: "FORGOT_OUT", label: "Forgot Out" },
  { id: "BOTH", label: "Both" },
];

export const DUMMY_HOLIDAYS = [
  { holidayId: "dummy-1", date: "15-08-2026", day: "Saturday", name: "Independence Day" },
  { holidayId: "dummy-2", date: "02-10-2026", day: "Friday", name: "Gandhi Jayanti" },
  { holidayId: "dummy-3", date: "20-10-2026", day: "Tuesday", name: "Dussehra" },
  { holidayId: "dummy-4", date: "08-11-2026", day: "Sunday", name: "Diwali" },
  { holidayId: "dummy-5", date: "09-11-2026", day: "Monday", name: "Diwali Holiday" },
  { holidayId: "dummy-6", date: "25-12-2026", day: "Friday", name: "Christmas" },
  { holidayId: "dummy-7", date: "01-01-2027", day: "Friday", name: "New Year" },
  { holidayId: "dummy-8", date: "14-01-2027", day: "Thursday", name: "Makar Sankranti" },
  { holidayId: "dummy-9", date: "26-01-2027", day: "Tuesday", name: "Republic Day" },
  { holidayId: "dummy-10", date: "14-03-2027", day: "Sunday", name: "Holi" },
];
